import React from 'react';
import img1 from '../../images/addProduct.png';
import img2 from '../../images/allProduct.png';
import { Link } from 'react-router-dom';
export default function Product(){
    return(
        <div className='container-fluid'>
            <h1 className='shadow-lg p-3 mb-5 bg-white rounded'>Products</h1>
            <div className='main'>
                <div className='d-flex justify-content-center'>
                    <div className='add-product-button'>
                        <Link className="btn btn-primary mx-2" to={'/product/create'}> {/* Handle Remainig */}
                            <p> Create Product Product </p>
                            <img src={img1} alt="Add Product Image" className='img_all'/>
                        </Link>
                    </div>
                </div>
                <div className='d-flex justify-content-center'>
                    <div className='add-product-button'>
                        <Link className="btn btn-primary mx-2" to={'/product/all'}> {/* Handle Remainig */}
                            <p className=''>Show All Products</p>
                            <img src={img2} alt="ALL Product Image"  className='img_all'/>
                        </Link>
                    </div>
                </div>
               
            </div>
        </div>
    );
}
//value={product.description}
//onChange={handleInputChange}